import React from 'react';

/** Riga canale di pubblicazione (hub struttura / mockup 05). */
export function ChannelRow({
  name,
  status = 'Attivo',
  detail,
  enabled = true,
  onToggle,
  className = '',
}) {
  return (
    <div
      className={[
        'flex flex-wrap items-center justify-between gap-3 border-b border-vc-line py-3',
        className,
      ].join(' ')}
    >
      <div className="min-w-0">
        <div className="font-semibold text-vc-ink">{name}</div>
        {detail && <div className="text-vc-sm text-vc-ink-2">{detail}</div>}
      </div>
      <div className="flex items-center gap-3">
        <span className="rounded-vc-sm bg-vc-surface-2 px-2 py-1 text-vc-xs font-medium text-vc-ink">
          {status}
        </span>
        {typeof onToggle === 'function' && (
          <button
            type="button"
            role="switch"
            aria-checked={enabled}
            className={[
              'relative h-7 w-12 rounded-full transition-colors',
              enabled ? 'bg-vc-slot' : 'bg-vc-line',
            ].join(' ')}
            onClick={() => onToggle(!enabled)}
          >
            <span
              className={[
                'absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-transform',
                enabled ? 'left-5' : 'left-0.5',
              ].join(' ')}
            />
          </button>
        )}
      </div>
    </div>
  );
}
